import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Modal } from '_zari/core'

import * as SedeService from 'services/sede.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const CrearEditarModal = ({ handleClose, show, reloadTable, editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      numeroInicial: editarData.numeroInicial ?? '',
      serie: editarData.serie ?? '',
      tipoSerie: editarData.tipoSerie ?? ''
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    data => {
      const opeFunc = editarData._id ? () => SedeService.actualizarSerie(editarData._id, data) : () => SedeService.nuevaSerie(data)

      opeFunc()
        .then(() => {
          __zariContext.snack('success', data._id ? 'El registro se ha actualizado.' : 'El registro se ha agregado.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, editarData, handleClose, reloadTable]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'EDITAR SERIE' : 'NUEVA SERIE'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.TipoDocumentoFormGroup iError={errors.tipoSerie} iTouched={touched.tipoSerie} fIsSubmitting={isSubmitting} />
              <FormGroups.SerieFormGroup iError={errors.serie} iTouched={touched.serie} fIsSubmitting={isSubmitting} />
              <FormGroups.NumeroInicialFormGroup iError={errors.numeroInicial} iTouched={touched.numeroInicial} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CrearEditarModal)
